module.exports = __webpack_public_path__ + "static/media/logo-privy-colored.c4c48ba4.png";